import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App";
import "./inJoy-components/index.css";
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_APP_SENTRY_DSN != null) {
	Sentry.init({
		dsn: import.meta.env.VITE_APP_SENTRY_DSN,
		// Setting this option to true will send default PII data to Sentry.
		// For example, automatic IP address collection on events
		sendDefaultPii: true,
	});

	console.debug("enable sentry");
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
